module.exports = __webpack_public_path__ + "img/warning.1ed4da93.png";